<template >
  <div class="container mycontainer">
    <h1 class="style-h3">Connexion</h1>
    <p>
      En vous connectant, vous aurez la possibilité de pouvoir vous inscrire à
      une formation ainsi qu'à la possibilité de gérer l'ensemble des formations
      où vous êtes inscrit.
    </p>
    <div class="row justify-content-md-center">
      <div class="col-12 col-lg-8">
        <form @submit.prevent="doLogin" class="form style-form style-login">
          <div class="row form-group">
            <div class="col">
              <label for="email">E-mail</label>
              <input
                type="mail"
                id="email"
                v-model="email"
                class="form-control"
                required
                placeholder="monmail@example.com"
              />
            </div>
          </div>
          <div class="row form-group">
            <div class="col">
              <label for="password">Mot de passe</label>
              <input
                :type="passwordType"
                id="password"
                v-model="password"
                class="form-control"
                required
                placeholder=""
              />
            </div>
          </div>
          <div class="row form-group">
            <div class="col">
              <button class="btn btn-primary btn-block mb-2" type="submit">
                Se connecter
              </button>
              <button
                v-on:click="sendEmail()"
                class="btn btn-default btn-block responsive-width"
                type="button"
              >
                Réinitialiser le mot de passe
              </button>
            </div>
          </div>
          <div class="form-group">
            <hr />
          </div>
          <a
            href="/inscription"
            class="btn btn-default btn-block responsive-width"
            title=""
            >Pas de compte ? Inscrivez-vous</a
          >
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import firebase from "firebase";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      hidePassword: true,
    };
  },
  computed: {
    passwordType() {
      return this.hidePassword ? "password" : "text";
    },
    passwordIcon() {
      return this.hidePassword ? "fa-eye" : "fa-eye-slash";
    },
  },
  methods: {
    showMsgBoxTwo() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk("Data was submitted successfully", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
        })
        .catch((err) => {
          // An error occurred
        });
    },
    sendEmail() {
      if (!this.email) {
        this.error = "Entrer une adresse email valide";
        alert(this.error);
        return;
      }
      this.error = null;
      this.emailSending = true;
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          alert(
            "Vous avez recu un email pour reinitialiser votre mot de passe"
          );
        })
        .catch((error) => {
          this.emailSending = false;
          this.error = error.message;
        });
    },
    doLogin() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          (user) => {
            this.$router.replace("home");
          },
          (err) => {
            alert("Oops. " + err.message);
          }
        );
    },
  },
};
</script>
<style scss>
body.is-home {
  background-image: None;
  background-size: 60%;
}
.form-group {
  margin-bottom: 3.6rem !important;
}
@media (max-width: 320px) {
  .btn {
    font-size: 3.5vw !important;
  }
}
</style>